const Founder = () => {
  return (
    <section data-testid="founder-section" id="founder" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-stretch">
          {/* Image */}
          <div className="relative flex">
            <div className="relative overflow-hidden rounded-2xl shadow-xl w-full">
              <img
                data-testid="founder-image"
                src="https://customer-assets.emergentagent.com/job_site-clone-quiz/artifacts/kubqqtsf_Gemini_Generated_Image_n9996n9996n9996n.png"
                alt="Scott Hardman - Founder & Principal Consultant"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-helix-orange/10 rounded-full -z-10"></div>
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-helix-blue/10 rounded-full -z-10"></div>
          </div>

          {/* Content */}
          <div className="lg:pl-8 flex flex-col justify-between h-full">
            <div>
              <span className="inline-block px-4 py-1.5 border border-helix-blue/30 rounded-full text-helix-blue text-xs tracking-[0.15em] uppercase font-medium mb-4 w-fit">
                Meet the Founder
              </span>
              <h2 data-testid="founder-title" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                A Career Dedicated to
                <br />
                <span className="text-helix-dark">Safety & Integrity</span>
              </h2>
            </div>
            <div className="flex-1 flex flex-col justify-between space-y-3 text-gray-600 leading-relaxed text-lg">
              <p>
                Scott Hardman is a senior security and intelligence professional specialising in OSINT collection, analysis, and risk reporting. His career began with NSW Police in criminal investigations, before delivering training with the Australian Federal Police to domestic and international agencies.
              </p>
              <p>
                He later served at the NSW Ombudsman, advising on whistleblower frameworks and integrity systems. In Tasmania Police, he coordinated statewide community policing, leading multi-agency intelligence strategies to identify patterns and respond to emerging risks.
              </p>
              <p>
                Today, Scott delivers decision-ready OSINT and structured threat assessments for security providers and corporate clients. His reporting transforms open-source data into clear, defensible intelligence that is timely, disciplined, and operationally focused.
              </p>
              <p>
                As Founder of HelixAspire, he advances OSINT capabilities through technology-enabled solutions including live intelligence dashboards, near real-time monitoring, and scalable products designed to detect early indicators and support proactive security outcomes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
